import React, { useState } from 'react';
import { useRef, useEffect } from "react";

import { Link } from "react-router-dom";
import { ArrowUpRight } from "react-feather"; // Using react-feather for the arrow icon
import "./ContactUs.css"
import { User, Mail, Phone, MessageSquare } from "lucide-react";
import SubscribeIcon from "../images/explore.png"; // Adjust the path to your circular icon image
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Navigation, Autoplay } from "swiper/modules";

// import { User, Mail, Phone } from "lucide-react";
function ContactUs() {

  // Prodcuts Series Starts

  const swiper1Ref = useRef(null);
  const swiper2Ref = useRef(null);

  // Function to attach hover events
  const attachHoverEvents = (swiperRef) => {
    if (swiperRef.current && swiperRef.current.el) {
      swiperRef.current.el.addEventListener("mouseenter", () => swiperRef.current.autoplay.stop());
      swiperRef.current.el.addEventListener("mouseleave", () => swiperRef.current.autoplay.start());
    }
  };

  // Attach event listeners when Swiper initializes
  useEffect(() => {
    if (swiper1Ref.current) attachHoverEvents(swiper1Ref);
    if (swiper2Ref.current) attachHoverEvents(swiper2Ref);
  }, []);

  useEffect(() => {
    if (swiper1Ref.current && swiper1Ref.current.swiper) {
      swiper1Ref.current.swiper.params.navigation.prevEl = ".prev1";
      swiper1Ref.current.swiper.params.navigation.nextEl = ".next1";
      swiper1Ref.current.swiper.navigation.init();
      swiper1Ref.current.swiper.navigation.update();
    }

    if (swiper2Ref.current && swiper2Ref.current.swiper) {
      swiper2Ref.current.swiper.params.navigation.prevEl = ".prev2";
      swiper2Ref.current.swiper.params.navigation.nextEl = ".next2";
      swiper2Ref.current.swiper.navigation.init();
      swiper2Ref.current.swiper.navigation.update();
    }
  }, []);
  //
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);


  const handleReachOut = (context) => {
    setShowFormPopup(true);
    setFormSubmitted(false); // Reset form submission when opening popup
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // You can add form validation or API call here
    setFormSubmitted(true);
  };


  // 

  // Form PHP
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    // Optional: basic validation
    if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
      setResponseMessage("Please fill in all fields.");
      setLoading(false);
      return;
    }

    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/contact-form-premier-pumps.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody,
      });

      const result = await response.json();

      if (result.status === "success") {
        setResponseMessage("Message sent successfully! ✅");
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          message: "",
        });
        setShowFormPopup(false); // close form
        setShowThankYouPopup(true); // open thank-you popup
      } else {
        setResponseMessage("Error: " + result.message);
      }
    } catch (error) {
      setResponseMessage("Error sending message. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Form PHP

  // newsletter form 
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState("");

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterStatus("Submitting...");

    try {
      const formData = new FormData();
      formData.append("email", newsletterEmail);

      const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/newsletter-premier-pumps.php", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setNewsletterStatus("✅ Successfully subscribed!");
        setNewsletterEmail("");
      } else {
        setNewsletterStatus("❌ Subscription failed. Please try again.");
      }
    } catch (error) {
      console.error("Newsletter Error:", error);
      setNewsletterStatus("⚠️ An error occurred. Please try again later.");
    }
  };

  // newsletter form 
  // Writing Items
  const writingItems = [
    {
      id: 9,
      image: require("../images/latest-writing/news-9.jpg"),
      name: "PV60",
      date: "29 July 2023",
      description: `
  <p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
`
    },




    {
      id: 3,
      image: require("../images/latest-writing/news-3.jpg"),
      name: "PV60",
      date: "16 November 2024",
      description: `
  <p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
  <p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
`
    },

    {
      id: 2,
      image: require("../images/latest-writing/news-7.jpeg"),
      name: "PV60",
      date: "09 January 2025",
      description: `
  <p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
`
    },


  ];
  // Writing Items
  return (
    <div>
      <section className="">
        <section class="container-fluid about-hero">
          <div class="container py-md-5">
            <div class="row align-items-center justify-content-center py-md-5 py-5">
              <div class="col-lg-3">
                <h2 class="fs-1 text-blue">Contact Us</h2>
              </div>
              <div class="col-lg-7">
                <p class="fs-5 fw-bold">For any inquiries contact our experts.
                </p>
                <p class="fs-5">

                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <div className='container py-5'>
          <div className="row">
            <div className="col-12 px-5">

              {/* <p>Got questions about the Landing Page UI Kit? Our team is here to help. Contact us for quick and
                        friendly support.</p> */}
            </div>
            <div className="col-lg-5 px-5 my-3">
              <h2 className='text-blue'>Let’s get in touch!</h2>
              <div className="d-flex justify-content-center flex-column my-5 gap-4">
                <div className="contact-link d-flex align-items-center gap-3">
                  <i className="fa-solid fa-phone-volume fs-4 text-blue"></i>
                  <a href="tel:+13042507078" className="fs-5 text-decoration-none text-dark">(304)-250-7078</a>

                </div>
                <div className="contact-link d-flex align-items-center gap-3">
                  <i className="fa-solid fa-phone-volume fs-4 text-blue"></i>
                  <a href="tel:256-438-5050" className="fs-5 text-decoration-none text-dark">256-438-5050</a>

                </div>
                <div className="contact-link d-flex align-items-center gap-3">
                  <i className="fa-regular fa-envelope fs-4 text-blue"></i>
                  <a href="maillto:support@premierpumps.com"
                    className="fs-5 text-decoration-none text-dark">support@premierpumps.com</a>
                </div>
                <div className="contact-link d-flex align-items-center gap-3">
                  <i className="fa-solid fa-location-dot fs-4 text-blue"></i>
                  <span className=" text-dark fs-5">
                    P.O.Box 1094, Gadsden, AL 35902, <br /> Work: 5902 Bulff Road, Boaz, AL 35956 - USA.
                  </span>
                </div>
                <div className="d-flex justify-content-center flex-column">
                  <h4 className="fw-bold ">Connect with us</h4>
                  <a href="https://www.linkedin.com/company/premier-pumps/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin className="linkedin-icon fs-1" />
                  </a>
                </div>

              </div>

            </div>
            <div className='col-lg-1 border-start border-primary'></div>
            <div className="col-lg-6 my-3 p-4">
              <div className="form-container">
                {!formSubmitted ? (
                  <form onSubmit={handleSubmit}>
                    <div className="input-group flex-column">

                      {/* Full Name */}
                      <label className="fw-medium">
                        Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-wrapper rounded-20 my-1 p-3">
                        <div className="d-flex align-items-center">
                          <User size={20} className="input-icon text-blue me-2" />
                          <input
                            name="fullName"
                            type="text"
                            placeholder="Enter your name"
                            className="form-control border-start rounded-0 ps-2"
                            required
                            value={formData.fullName}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* Email */}
                      <label className="fw-medium">
                        Email <span className="text-danger">*</span>
                      </label>
                      <div className="input-wrapper rounded-20 my-1 p-3">
                        <div className="d-flex align-items-center">
                          <Mail size={20} className="input-icon text-blue me-2" />
                          <input
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            className="form-control border-start rounded-0 ps-2"
                            required
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* Phone */}
                      <label className="fw-medium">Phone</label>
                      <div className="input-wrapper rounded-20 my-1 p-3">
                        <div className="d-flex align-items-center">
                          <Phone size={20} className="input-icon text-blue me-2" />
                          <input
                            name="phone"
                            type="tel"
                            placeholder="Enter your phone number"
                            className="form-control border-start rounded-0 ps-2"
                            value={formData.phone}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                "Tab", "Home", "End", "+", "-", "(", ")", " "
                              ];
                              const isNumber = /^[0-9]$/.test(e.key);
                              const isAllowed = allowedKeys.includes(e.key);
                              if (!isNumber && !isAllowed) e.preventDefault();
                            }}
                          />
                        </div>
                      </div>

                      {/* Message */}
                      <label className="fw-medium mt-3">Message</label>
                      <div className="input-wrapper rounded-20 my-1 p-3">
                        <textarea
                          name="message"
                          placeholder="Your Message"
                          rows="4"
                          className="form-control rounded-0 ps-2"
                          required
                          value={formData.message}
                          onChange={handleChange}
                        />
                      </div>

                      {/* Submit Button */}
                      <div className="d-flex justify-content-center">
                        <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                          {loading ? "Sending..." : "Submit"}
                        </button>
                      </div>
                    </div>

                    {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                  </form>
                ) : (
                  <div className="text-center p-4">
                    <p>Thank you for reaching out! We'll get back to you soon.</p>
                    <button
                      className="btn btn-primary mt-3 px-4"
                      onClick={() => {
                        setFormSubmitted(false);
                        setShowThankYouPopup(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Contact Section */}

        {/* thank you popup  */}

        {showThankYouPopup && (
          <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
            <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
              <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
                <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.com' >support@premierpumps.com</a></p>
                <button
                  className="btn btn-primary mt-3 px-4"
                  onClick={() => setShowThankYouPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}


        {/* thank you popup  */}

        {/* Latest Writing */}
        <div className="latest-writing-section mb-5">
          <div className="container">
            <h3 className="fw-bold mb-4">Latest Writing</h3>
            <Swiper
              ref={swiper1Ref}
              onSwiper={(swiper) => (swiper1Ref.current = swiper)}
              modules={[Autoplay, Navigation]}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={1000}
              loop={true}
              slidesPerView={4}
              spaceBetween={20}
              navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
              breakpoints={{
                320: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
              onMouseEnter={() => swiper1Ref.current?.autoplay.stop()}
              onMouseLeave={() => swiper1Ref.current?.autoplay.start()}
            >
              {writingItems.map((item) => {
                const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
                const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;

                return (
                  <SwiperSlide key={item.id} className="h-100">
                    <Link
                      to={`/writing-details/${item.id}`}
                      state={{
                        name: item.name,
                        date: item.date,
                        description: item.description,
                        image: item.image
                      }}
                      className="text-decoration-none h-100 d-block"
                    >
                      <div className="writing-slide-card bg-white shadow-sm h-100">
                        <div className="d-flex flex-column h-100">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="card-img-top mx-auto rounded-3"
                          />
                          <div className="card-body mt-auto p-3 fs-sm-12">
                            {/* <p className="">{item.date}</p> */}
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="mb-0 text-dark small flex-grow-1 me-3">{shortText}</p>
                              <ArrowUpRight size={20} className="text-blue flex-shrink-0" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            {/* Custom Navigation Buttons */}
            <div className="d-flex justify-content-end mt-4">
              <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
              <button className="btn btn-outline-primary next1  px-4 py-0 fs-5">&#8250;</button>
            </div>
            <div className='text-center d-flex justify-content-center'>
              <Link to="/news" className="text-decoration-none">
                <Button
                  variant="outline-primary text-dark rounded"
                  className="d-flex align-items-center py-2 px-4 fs-5 rounded my-md-0 my-2"
                >
                  View All <ArrowUpRight size={18} className="ms-2" />
                </Button>
              </Link>

            </div>


          </div>
        </div>
        {/* Latest Writing */}
        {/* Explore Starts */}
        {/* // Subscribe Newsletter Section */}
        <div className="subscribe-newsletter-section my-md-5 my-0">
          <div className="container py-3">
            <div className="subscribe-inner">
              <div className="row align-items-center justify-content-between">
                <div className="col-lg-3 col-md-3 col-sm-12 text-center text-md-start mb-3 mb-md-0">
                  <img
                    src={SubscribeIcon}
                    alt="Subscribe Icon"
                    className="subscribe-icon img-fluid floating"
                  />
                </div>
                <div className="col-lg-6 col-md-9 col-sm-12">
                  <div className="subscribe-content">
                    <h3 className="subscribe-heading mb-3 fw-bold text-md-start text-center">
                      Subscribe Newsletter
                    </h3>
                    <form onSubmit={handleNewsletterSubmit}>
                      <div className="d-flex align-items-center justify-content-md-start justify-content-center position-relative">
                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={newsletterEmail}
                          onChange={(e) => setNewsletterEmail(e.target.value)}
                          required
                          className="form-control subscribe-input me-2 py-4 bg-white border-0 rounded-15"
                        />
                        <button
                          type="submit"
                          className="btn subscribe-button py-2 fs-5 px-4 position-absolute end-0 me-3"
                        >
                          <i className="fa-regular fa-envelope me-md-4 me-2 fs-4"></i>
                          Subscribe
                        </button>
                      </div>
                    </form>
                    {newsletterStatus && <p>{newsletterStatus}</p>}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Explore Ends */}
      </section>
    </div>
  )
}

export default ContactUs